export default __webpack_public_path__ + "static/media/logo.4417d22b.svg";